var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAggregationCriteria = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.924,
    height: 18.279,
    viewBox: "0 0 13.924 18.279",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checklist",
    transform: "translate(-61)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48619",
    "data-name": "Path 48619",
    d: "M61,0V18.279H74.924v-14H70.64V0Zm3.749,14.181-1.45-1.45.757-.757.692.692,1.228-1.228.757.757Zm0-3.213L63.3,9.518l.757-.757.692.692,1.228-1.228.757.757Zm0-3.213L63.3,6.305l.757-.757.692.692,1.228-1.228.757.757Zm8.033,6.2H67.426V12.888h5.355Zm0-3.213H67.426V9.675h5.355Zm0-4.284V7.533H67.426V6.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48620",
    "data-name": "Path 48620",
    d: "M361,11.688h2.9l-2.9-2.9Z",
    transform: "translate(-289.289 -8.475)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAggregationCriteria);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_aggregation_criteria.e4cbefb9bc119401fbeae7359a5d9abe.svg";